export { default as MotionBox } from './motion-box';
export { default as MotionHeading } from './motion-heading';
export { default as MotionMain } from './motion-main';

export type { MotionBoxProps } from './motion-box';
export type { MotionHeadingProps } from './motion-heading';
export type { MotionMainProps } from './motion-main';
